/* eslint-disable no-unused-vars */
export const slides = [
  'https://ik.imagekit.io/3hfv2fjcvxul/60dc202e74229-slate-grey-clear-lens-front-1000-web_470x470.png',
  'https://ik.imagekit.io/3hfv2fjcvxul/6089ccaf28795-slate-grey-clear-lens-iso-1000-web_470x470.png',
  'https://ik.imagekit.io/3hfv2fjcvxul/6089ccbee4eda-slate-grey-clear-lens-side-1000-web_470x470.png'
];

export enum FrameSizeEnum {
	EXTRA_SMALL = "Extra Small",
	SMALL = "Small",
	MEDIUM = "Medium",
	LARGE = "Large"
}

export enum CategoryEnum {
	PRESCRIPTION_GLASSES = "prescription-glasses",
	BLUE_LIGHT_FILTER_GLASSES = "blue-light-filter-glasses",
	PRESCRIPTION_SUNGLASSES = "prescription-sunglasses",
	NON_PRESCRIPTION_SUNGLASSES = "non-prescription-sunglasses",
	SUNGLASSES = "sunglasses"
}
